import { render, staticRenderFns } from "./HeaderContainer.vue?vue&type=template&id=308a7b1a"
import script from "./HeaderContainer.vue?vue&type=script&lang=js"
export * from "./HeaderContainer.vue?vue&type=script&lang=js"
import style0 from "./HeaderContainer.vue?vue&type=style&index=0&id=308a7b1a&prod&lang=less&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports